// extracted by mini-css-extract-plugin
export default {"userinfo_icon":"styles_userinfo_icon__qjP+m","input":"styles_input__aZZYk"};